/* BLUE LACES — Carrito inteligente (assets/bl-cart.js)
   Cambiar talla, agregar upsell y aplicar código sin recargar. Re-renderiza usando las secciones de Dawn. */
(function () {
  if (window.__blCartInit) return; window.__blCartInit = true;
  var R = window.routes || {}; var cartUrl = R.cart_url || '/cart';
  function drawer() { return document.querySelector('cart-drawer'); }
  function setLoading(on) { var d = document.querySelector('.bl-cart'); if (d) d.classList.toggle('is-loading', !!on); }
  function rerender() {
    return fetch(cartUrl + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var dp = new DOMParser();
        var cd = document.getElementById('CartDrawer');
        if (cd && s['cart-drawer']) cd.innerHTML = dp.parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer').innerHTML;
        var bub = document.getElementById('cart-icon-bubble');
        if (bub && s['cart-icon-bubble']) bub.innerHTML = dp.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
        var d = drawer(); if (d) { var ov = d.querySelector('#CartDrawer-Overlay'); if (ov) ov.addEventListener('click', d.close.bind(d)); d.open(); }
      });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-bl-size]'); if (!sel) return;
    var line = +sel.dataset.line, qty = +sel.dataset.qty, id = +sel.value;
    setLoading(true);
    post(cartUrl + '/change.js', { line: line, quantity: 0 })
      .then(function () { return post(cartUrl + '/add.js', { items: [{ id: id, quantity: qty }] }); })
      .then(rerender).catch(function () { setLoading(false); alert('No se pudo cambiar la talla, intenta de nuevo.'); });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bl-add]'); if (!b) return;
    e.preventDefault(); b.disabled = true; setLoading(true);
    post(cartUrl + '/add.js', { items: [{ id: +b.dataset.blAdd, quantity: 1 }] })
      .then(rerender).catch(function () { setLoading(false); b.disabled = false; });
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-bl-discount]'); if (!f) return;
    e.preventDefault();
    var code = (f.querySelector('input[name=discount]').value || '').trim();
    var old = f.querySelector('.bl-msg'); if (old) old.remove();
    setLoading(true);
    post(cartUrl + '/update.js', { discount: code })
      .then(function (c) {
        var ok = code === '' || (c.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
        return rerender().then(function () {
          if (!ok) { var f2 = document.querySelector('[data-bl-discount]'); if (f2) { var m = document.createElement('div'); m.className = 'bl-msg'; m.textContent = 'Ese código no aplica a este carrito.'; f2.appendChild(m); } }
        });
      }).catch(function () { setLoading(false); });
  });
})();
